// @flow
import moment from 'moment';

export const API_DATE_FORMAT: string = 'YYYYMMDD';
const API_TIME_FORMAT: string = 'HH:mm:ss.SSS';
export const UTC_DATE_TIME_FORMAT: string = 'YYYYMMDDTHH:mm:ss.SSSZ';

export function momentFromApiDate(apiDate: string): moment$Moment {
  return moment(apiDate, API_DATE_FORMAT);
}

export function momentToApiDate(date: moment$Moment): string {
  return date.format(API_DATE_FORMAT);
}

export function momentFromApiTime(apiTime: string): moment$Moment {
  return moment(apiTime, API_TIME_FORMAT);
}

export function momentToApiTime(date: moment$Moment): string {
  return date.format(API_TIME_FORMAT);
}

export function apiDateToTimestamp(apiDate: ?string | number): ?timestamp {
  return apiDate ? moment(apiDate, API_DATE_FORMAT).valueOf() : null;
}

export function timestampToApiDate(timestamp: ?timestamp | string): ?string {
  return timestamp ? moment(timestamp).format(API_DATE_FORMAT) : null;
}

export function formatApiDate(apiDate: string, format: string): string {
  return moment(apiDate, API_DATE_FORMAT).format(format);
}

export function getPeriodsMoment(date: moment$Moment): string {
  return date.hours() > 12 ? 'PM' : 'AM';
}
